import { gql } from '@apollo/client';

const GET_MESSAGE_AUDIENCE_ESTIMATE = gql`
  query GetMessageAudienceEstimate($input: GetMessageAudienceEstimate!) {
    getMessageAudienceEstimate(input: $input) {
      audienceCount
    }
  }
`;

export default GET_MESSAGE_AUDIENCE_ESTIMATE;
